import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/storage';
import 'firebase/compat/firestore';
import 'firebase/compat/analytics';
import 'firebase/compat/functions'; // Add compat functions

const firebaseConfig = {
  apiKey: "AIzaSyDhRPs2rBwuHs4Y8bp_-pCMloFprrQfuIo",
  authDomain: "xyronis-8cc09.firebaseapp.com",
  projectId: "xyronis-8cc09",
  storageBucket: "xyronis-8cc09.firebasestorage.app",
  messagingSenderId: "537796351623",
  appId: "1:537796351623:web:551f1da0ba1aa9622eca22",
  measurementId: "G-J0SWCKVCNV"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
console.log('Firebase initialized:', app.name);

const auth = firebase.auth();
const storage = firebase.storage();
const db = firebase.firestore();
const analytics = firebase.analytics();
const functions = firebase.functions(); // Use compat functions

console.log('Analytics initialized');

export { auth, storage, db, analytics, functions };